import React from 'react'
import { Field, FieldArray, reduxForm } from 'redux-form'
import Moment from "moment";
import { Button, Table } from 'react-bootstrap';
import FieldFileInput from './FieldFileInput';

const required = value => value ? undefined : 'Required'
const number = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined

function normalizeDate(value, prevValue) {
  if (!value) return value;

  const valueOnlyNumbers = value.replace(/[^\d]/g, '');
  const prevValueOnlyNumbers = prevValue && prevValue.replace(/[^\d]/g, '');

  // Enable backspacing:
  // if the user is backspacing and they backspace a forward slash, the date's
  // numbers won't be affected so just return the value.
  if (valueOnlyNumbers === prevValueOnlyNumbers) return value;

  const month = valueOnlyNumbers.slice(0, 2);
  // const day = valueOnlyNumbers.slice(2, 4);
  const year = valueOnlyNumbers.slice(2, 6);

  if (valueOnlyNumbers.length < 2) return `${month}`;
  if (valueOnlyNumbers.length == 2) return `${month}/`;
  if (valueOnlyNumbers.length < 6) return `${month}/${year}`;
  if (valueOnlyNumbers.length == 6) return `${month}/${year}`;
  if (valueOnlyNumbers.length > 6) return `${month}/${year}`;

  // if (valueOnlyNumbers.length > 4) return `${month}/${day}/${year}`;
}

const renderField = ({ input, label, type, meta: { touched, error } }) => (
    <div>
      <input {...input} type={type} placeholder={label} style={{width: '100%'}} />
      {touched && error && <span>{error}</span>}
    </div>
)



const renderFields = ({ fields, helpText, helpTitle, meta: { error } }) => (
  <React.Fragment>
    {fields.map((page, index) => (
      <React.Fragment key={index}>
        <tr style={{background: '#00800038'}}>
            <td>
              <Field
                name={`${page}`}
                type="text"
                component={renderField}
                label={helpTitle}
                validate={[ required ]}
              />
            </td>
            <td>
              <button type="button" onClick={() => fields.remove(index)}>❌</button>
            </td>
        </tr>
      </React.Fragment>
    ))}
    <tr>
        <td colSpan="2">
          <button type="button" className="btn btn-primary btn-sm" onClick={() => fields.push()}>
            {helpText}
          </button>
        </td>
    </tr>
  </React.Fragment>
)


const MeUploadForm = props => {
	const { handleSubmit, submitting, reset, pristine, initialValues} = props
	return (
     <form onSubmit={handleSubmit}>
       <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Publication Date (DD/YYYY)</th>
          </tr>
        </thead>
        <tbody>
          
          <tr style={{background: '#00800038'}}>
            <td>
              <Field
                name={`sku`}
                type="text"
                component={renderField}
                label={`SKU`}
                validate={[ required ]}
              />
            </td>
            <td>
              <Field
                name={`publication_date`}
                normalize={normalizeDate}
                component={renderField}
                label={`Publication Date`}
                validate={[ required ]}
              />
            </td>
          </tr>
          <tr colSpan="2" className="mt-2 mb-2"><td>Upload a file ( .xlsx file only)</td></tr>
          <tr>
            <td>
               <Field component={FieldFileInput} validate={[ required ]} name="file_source" type="file" />
            </td>
          </tr>
          
          <tr colSpan="2" className="mt-2 mb-2"><td>Domain ( <b>insightmonk</b>, <b>intel</b> ) </td></tr>
          <FieldArray name="domain" helpText="Add New Domain" helpTitle="Domain Name" component={renderFields} />

          <tr colSpan="2" className="mt-2 mb-2"><td>Tags</td></tr>
          <FieldArray name="tags" helpText="Add New Tag" helpTitle="Tag Name" component={renderFields} />
        </tbody>
        </Table>
        <div className="p-1">
          <button type="submit" className="btn btn-success btn-sm mr-2" disabled={submitting}>
            Save Changes
          </button>
          <button type="button" className="btn btn-primary btn-sm" disabled={pristine || submitting} onClick={reset}>
            Undo Values
          </button>
        </div>
    </form>
  )
}

export default reduxForm({
  form: 'MeUploadForm', // a unique identifier for this form
  enableReinitialize: true
})(MeUploadForm)


// WEBPACK FOOTER //
// ./src/components/Insights/MeUploadForm.js